import Link from 'next/link';

import { SUPPORTED_CHAIN_IDS } from '@/constants/chain';

import { fontStyles } from '@/styles/typography';

import { ChevronDownSmallIcon } from '@/ui/Icons/ChevronDownSmallIcon';

import { routes } from '@/utils/routes';

export function MarketingLiquiditySection({
  bodyText = `Zero fee trades on 9+ million tokens across ${SUPPORTED_CHAIN_IDS.length} chains. Get the best prices by tapping
    into 130+ liquidity sources.`,
}) {
  return (
    <div className="flex flex-col gap-8 mx-16 my-56">
      <div className="bg-special-background-card rounded-t-2xl rounded-b-lg overflow-hidden">
        <div className="p-24 pt-68 bg-[image:url(/images/new-landing/liquidity-bg-mobile-light.webp)] bg-[top_right/contain] bg-no-repeat tablet:bg-[image:url(/images/new-landing/liquidity-bg-tablet-light.webp)] desktop:bg-[image:url(/images/new-landing/liquidity-bg-desktop-light.webp)] [body[data-theme='dark']_&]:bg-[image:url(/images/new-landing/liquidity-bg-mobile-dark.webp)] [body[data-theme='dark']_&]:tablet:bg-[image:url(/images/new-landing/liquidity-bg-tablet-dark.webp)] [body[data-theme='dark']_&]:desktop:bg-[image:url(/images/new-landing/liquidity-bg-desktop-dark.webp)] [body[data-theme='system']_&]:bg-[image:url(/images/new-landing/liquidity-bg-mobile-light.webp)] [body[data-theme='system']_&]:tablet:bg-[image:url(/images/new-landing/liquidity-bg-tablet-light.webp)] [body[data-theme='system']_&]:desktop:bg-[image:url(/images/new-landing/liquidity-bg-desktop-light.webp)] [body[data-theme='system']_&]:[@media(prefers-color-scheme:dark)]:bg-[image:url(/images/new-landing/liquidity-bg-mobile-dark.webp)] [body[data-theme='system']_&]:[@media(prefers-color-scheme:dark)]:tablet:bg-[image:url(/images/new-landing/liquidity-bg-tablet-dark.webp)] [body[data-theme='system']_&]:[@media(prefers-color-scheme:dark)]:desktop:bg-[image:url(/images/new-landing/liquidity-bg-desktop-dark.webp)]">
          <div className="flex flex-col gap-6 items-center mt-80 mb-42 tablet:w-[362px] tablet:mx-auto desktop:w-[362px] desktop:-mt-8 desktop:ml-36 desktop:items-start">
            <div
              className={fontStyles({
                variant: 'H2',
                class: [
                  'text-token-gray-1600',
                  'text-center',
                  'desktop:text-left',
                  'before:hidden',
                  'after:hidden',
                ],
              })}
            >
              More than 130+ liquidity sources
            </div>
            <div
              className={fontStyles({
                variant: 'H5',
                class: [
                  'text-token-gray-800',
                  'text-center',
                  'desktop:text-left',
                  'before:hidden',
                  'after:hidden',
                ],
              })}
            >
              {bodyText}
            </div>
            <Link target="_blank" referrerPolicy="no-referrer" href={routes.LIQUIDITY_SOURCES}>
              <div className="inline-flex items-center justify-center content-center border-none ease-in-out duration-[200ms] disabled:transform-none disabled:cursor-not-allowed active:outline-none active:scale-[0.98] px-3 h-9 w-fit font-body text-[14px] leading-[16px] font-medium rounded-2xl text-token-gray-1600 bg-token-gray-200 hover:bg-token-alphalight-300 active:bg-token-alphalight-400 focus-visible:bg-token-alphalight-200 focus-visible:outline-token-alphalight-500">
                Learn more <ChevronDownSmallIcon className="ml-2 rotate-[-90deg]" />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
